module.exports = __webpack_public_path__ + "static/media/driver.b9931b07.png";